import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex items-center justify-end my-4 mr-4 space-x-2 text-sm text-white"
}
const _hoisted_2 = { class: "mb-2 md:mb-0" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", {
  for: "perPage",
  class: "mr-2"
}, "Éléments par page :", -1)
const _hoisted_4 = ["value"]
const _hoisted_5 = ["value"]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "px-2 py-1" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = ["disabled"]

import { computed } from "vue";

	
export default /*#__PURE__*/_defineComponent({
  __name: 'PaginationTag',
  props: {
		meta: {
			type: Object,
			required: true,
			default: () => ({
				current_page: 1,
				last_page: 1,
			}),
		},
		perPageOptions: {
			type: Array as () => number[],
			default: () => [10, 15, 25, 30, 40, 50, 75, 80, 100],
		},
	},
  emits: ["page-change", "per-page-change"],
  setup(__props, { emit: __emit }) {

	const props = __props;

	const emit = __emit;

	const isFirstPage = computed(() => props.meta.current_page === 1);
	const isLastPage = computed(() => props.meta.current_page === props.meta.last_page);

	function handlePageChange(newPage: number) {
		if (newPage >= 1 && newPage <= props.meta.last_page) {
			emit("page-change", newPage);
		}
	}

	function changePerPage(event: Event) {
		const value = parseInt((event.target as HTMLSelectElement).value, 10);
		emit("per-page-change", value);
	}


return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!

  return (__props.meta.last_page > 1)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("select", {
            id: "perPage",
            onChange: changePerPage,
            value: __props.meta.per_page,
            class: "px-2 py-1 text-white bg-[#0e181c] rounded"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.perPageOptions, (option) => {
              return (_openBlock(), _createElementBlock("option", {
                key: option,
                value: option
              }, _toDisplayString(option), 9, _hoisted_5))
            }), 128))
          ], 40, _hoisted_4)
        ]),
        _createElementVNode("button", {
          class: "flex items-center px-2 py-1 bg-[#0e181c] hover:bg-gray-600 rounded disabled:opacity-50",
          disabled: isFirstPage.value,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (handlePageChange(1)))
        }, " Première ", 8, _hoisted_6),
        _createElementVNode("button", {
          class: "flex items-center px-2 py-1 bg-[#0e181c] hover:bg-gray-600 rounded disabled:opacity-50",
          disabled: __props.meta.current_page === 1,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (handlePageChange(__props.meta.current_page - 1)))
        }, [
          _createVNode(_component_Icon, {
            src: "'/media/icons/arrow-2-left-icon.svg'",
            css: "w-6 h-6"
          })
        ], 8, _hoisted_7),
        _createElementVNode("span", _hoisted_8, " Page " + _toDisplayString(__props.meta.current_page) + " sur " + _toDisplayString(__props.meta.last_page), 1),
        _createElementVNode("button", {
          class: "flex items-center px-2 py-1 bg-[#0e181c] hover:bg-gray-600 rounded disabled:opacity-50",
          disabled: __props.meta.current_page === __props.meta.last_page,
          onClick: _cache[2] || (_cache[2] = ($event: any) => (handlePageChange(__props.meta.current_page + 1)))
        }, [
          _createVNode(_component_Icon, {
            src: "'/media/icons/arrow-2-right-icon.svg'",
            css: "w-6 h-6"
          })
        ], 8, _hoisted_9),
        _createElementVNode("button", {
          class: "flex items-center px-2 py-1 bg-[#0e181c] hover:bg-gray-600 rounded disabled:opacity-50",
          disabled: isLastPage.value,
          onClick: _cache[3] || (_cache[3] = ($event: any) => (handlePageChange(__props.meta.last_page)))
        }, " Dernière ", 8, _hoisted_10)
      ]))
    : _createCommentVNode("", true)
}
}

})